const INR = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
});
const INR2 = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 2,
});
const NUM = new Intl.NumberFormat('en-IN');

export function money(value: string | number | null | undefined, decimals = false): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(n)) return '—';
  return decimals ? INR2.format(n) : INR.format(n);
}

export function num(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '0';
  return NUM.format(typeof value === 'string' ? Number(value) : value);
}

export function weight(value: string | number | null | undefined, unit = 'g'): string {
  if (value === null || value === undefined || value === '') return '—';
  const s = String(value);
  return `${s} ${unit}`;
}

export function pct(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—';
  return `${n.toFixed(1)}%`;
}

export function dateShort(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function dateTime(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function dateRange(from: string | Date, to: string | Date): string {
  return `${dateShort(from)} – ${dateShort(to)}`;
}

export function titleCase(s: string | null | undefined): string {
  if (!s) return '';
  return s.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
}
